import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col pb-5 pt-14 px-9 min-w-96" };
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M23.6 10.3a10.7 10.7 0 0121.4.4v15.4a3.5 3.5 0 007 0V10.5a10.5 10.5 0 0121 0v16c0 1.9 1.6 3.5 3.5 3.5 2 0 3.5-1.6 3.5-3.5v-16a10.5 10.5 0 0121 0v15.6a3.5 3.5 0 007 0V10.7a10.7 10.7 0 0121.4-.4l1 22.5a53.9 53.9 0 11-107.6 0l.8-22.5z",
    fill: "#904C6F"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "21.9",
    y: "10.5",
    width: "23.6",
    height: "12.2",
    rx: "2",
    fill: "#F7F7FF"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "50.4",
    y: "10.5",
    width: "23.6",
    height: "12.2",
    rx: "2",
    fill: "#F7F7FF"
}, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "78.9",
    y: "10.5",
    width: "23.6",
    height: "12.2",
    rx: "2",
    fill: "#F7F7FF"
}, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "107.4",
    y: "10.5",
    width: "23.6",
    height: "12.2",
    rx: "2",
    fill: "#F7F7FF"
}, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M55.6 12.8a.9.9 0 110 1.8.9.9 0 010-1.8zm1.7 3.5a.9.9 0 110 1.8.9.9 0 010-1.8zM54.7 19a.9.9 0 110 1.7.9.9 0 010-1.8zm58.3-6.2a.9.9 0 010 1.8.9.9 0 010-1.7zm1.7 3.5a.9.9 0 010 1.8.9.9 0 010-1.7zM112 19a.9.9 0 01.1 1.7.9.9 0 010-1.7zm-86-6.2a.9.9 0 110 1.8.9.9 0 010-1.8zm3.3-.5a.9.9 0 110 1.8.9.9 0 010-1.8zM25.2 19a.9.9 0 110 1.7.9.9 0 010-1.8zm58.2-6.2a.9.9 0 110 1.8.9.9 0 010-1.8zm3.2-.5a.9.9 0 110 1.8.9.9 0 010-1.8zM82.5 19a.9.9 0 110 1.7.9.9 0 010-1.8z",
    fill: "#DDDBEA"
}, null, -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M31 48.7c0 1.4-.9 2-1.8 2-1 0-1.8-.6-1.8-2 0-1.5 1.3-3 1.8-3.3.9.7 1.7 1.8 1.7 3.3zm14.5-8.4c0 1.4-.8 2-1.8 2s-1.7-.6-1.7-2 1.2-2.9 1.7-3.3c1 .7 1.8 1.9 1.8 3.3zm76 15c0 1.4-.8 2-1.8 2s-1.7-.6-1.7-2 1.2-2.9 1.7-3.3c1 .7 1.8 1.9 1.8 3.3z",
    stroke: "#F7F7FF",
    "stroke-width": "1.3"
}, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M84.6 57.2a8.3 8.3 0 00-8.8 2.4",
    stroke: "#00292B",
    "stroke-width": "3",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "68.5",
    cy: "45.9",
    fill: "#00292B",
    r: "1.4"
}, null, -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "85.2",
    cy: "45.9",
    fill: "#00292B",
    r: "1.4"
}, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M88 43.8s-5 1.4-10.9 1.4c-6 0-11.4-1.4-11.4-1.4",
    stroke: "#00292B",
    "stroke-width": "3",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("path", {
    fill: "#DDDBEA",
    d: "M0 77.2h138v27.3H0z"
}, null, -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("path", {
    fill: "#BBB7D5",
    d: "M24.6 89h105.9v3.8H24.6z"
}, null, -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "14.3",
    cy: "90.9",
    r: "2",
    fill: "#FF7645"
}, null, -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "7.5",
    cy: "90.9",
    r: "2",
    fill: "#fff"
}, null, -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M49.3 95.8v-7h5.3v7c0 6.6-2.5 13-7.1 17.6l-1.9-1.9-1.9-1.9c3.6-3.6 5.6-8.6 5.6-13.8zm53.7.2v-7.2h-5.3V96a25 25 0 007.2 17.4l1.8-1.9 2-1.9A19.5 19.5 0 01103 96zm-7.4-7.2V105l1 8-5.3.6-1-8V88.7h5.3zm-38.8 12v-12H62v12c0 3-.3 6-.8 9L61 112l-5.2-.9.3-2.1c.4-2.8.7-5.5.7-8.3zm17-12V105l-.5 10.2 5.3.3.5-10.3V88.8h-5.3zm-8.5 16.3V88.8h5.3V105l1 7.9-5.2.7-1.1-8v-.4zm17-16.3v12.3c0 2.8.2 5.6.6 8.3l.5 3.6 5.3-.8-.6-3.6a52 52 0 01-.5-7.5V88.8h-5.3z",
    fill: "#904C6F"
}, null, -1);
const _hoisted_19 = [
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    _hoisted_18
];
const _hoisted_20 = { class: "text-2xl font-bold mt-7 text-primary-900 dark:text-white" };
const _hoisted_21 = { class: "w-0 min-w-full mt-3 text-sm-but-a-bit-smaller" };
const _hoisted_22 = { class: "font-bold text-gray-250 dark:text-gray-200" };
const _hoisted_23 = { class: "flex items-start justify-between pr-5 mt-5" };
const _hoisted_24 = { class: "leading-snug text-sm-but-a-bit-smaller" };
const _hoisted_25 = { class: "pb-3 text-gray-500 dark:text-gray-100" };
const _hoisted_26 = { class: "pb-3 pl-3 font-bold" };
const _hoisted_27 = { class: "text-gray-500 dark:text-gray-100" };
const _hoisted_28 = { class: "pl-3 font-bold" };
const _hoisted_29 = { class: "flex justify-end gap-8 mt-14" };
const _hoisted_30 = {
    key: 1,
    class: "flex justify-end mt-15"
};
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.delete_seats_modal'),
    compatConfig: {
        COMPONENT_V_MODEL: false
    }
};
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { RouterLink } from 'vue-router';
import transitions from '@/helpers/transitions';
import Modal from '@/components/Modal.vue';
import Dialog from '@/components/Dialog.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'DeleteSeatsModal',
    props: {
        isVisible: { type: Boolean }
    },
    emits: ['update:isVisible'],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const { scaleIn, scaleOut } = transitions.scale;
        const defaultSeatsToDelete = 0;
        const seatsToDelete = ref(defaultSeatsToDelete);
        const isDeleteSeatsLoading = ref(false);
        const seatsAvailable = computed(() => store.getters.seatsAvailable);
        const workspace = computed(() => store.getters.workspace);
        const deleteSeatsDisabledReason = computed(() => {
            if (seatsToDelete.value === 0) {
                return 'min_disabled';
            }
            if (seatsToDelete.value > seatsAvailable.value) {
                return 'max_disabled';
            }
            return null;
        });
        watch(() => props.isVisible, () => (seatsToDelete.value = defaultSeatsToDelete));
        function close() {
            emit('update:isVisible', false);
        }
        async function onDeleteSeats() {
            isDeleteSeatsLoading.value = true;
            await store.dispatch('updateWorkspace', {
                seats: workspace.value.seats - seatsToDelete.value,
                workspaceId: workspace.value.id
            });
            isDeleteSeatsLoading.value = false;
            seatsToDelete.value = defaultSeatsToDelete;
            // Note: This is optimistic but currently we can't detect a failure when
            // calling the `updateWorkspace` action.
            store.dispatch('flashThenClear', { message: 'workspace_seats_updated' });
            close();
        }
        return (_ctx, _cache) => {
            const _component_NumberField = _resolveComponent("NumberField");
            const _component_TextButton = _resolveComponent("TextButton");
            const _component_PillButton = _resolveComponent("PillButton");
            const _component_TransitionA11y = _resolveComponent("TransitionA11y");
            return (_openBlock(), _createBlock(Modal, null, {
                default: _withCtx(() => [
                    _createVNode(_component_TransitionA11y, {
                        css: false,
                        enter: _unref(scaleIn),
                        leave: _unref(scaleOut),
                        class: "px-2 my-2"
                    }, {
                        default: _withCtx(() => [
                            (__props.isVisible)
                                ? (_openBlock(), _createBlock(Dialog, {
                                    key: 0,
                                    class: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("section", _hoisted_1, [
                                            (_openBlock(), _createElementBlock("svg", {
                                                width: "138",
                                                height: "116",
                                                viewBox: "0 0 138 116",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                "svg-inline": '',
                                                class: _normalizeClass('self-center w-34'),
                                                src: '@/assets/images/dude-being-shredded.svg',
                                                alt: ''
                                            }, _hoisted_19, 8, _hoisted_2)),
                                            _createElementVNode("h1", _hoisted_20, _toDisplayString(_unref(seatsAvailable) > 0 ? _ctx.$t('seats_title') : _ctx.$t('no_seats_title')), 1),
                                            _createElementVNode("p", _hoisted_21, [
                                                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('description_1')), 1),
                                                _createVNode(_unref(RouterLink), {
                                                    class: "text-blue-link dark:text-blue-light-link",
                                                    to: { name: 'membersWorkspace' }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('description_2')), 1)
                                                    ], undefined, true),
                                                    _: 1
                                                })
                                            ]),
                                            (_unref(seatsAvailable) > 0)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _createElementVNode("table", _hoisted_24, [
                                                            _createElementVNode("tr", null, [
                                                                _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$t('available_seats')), 1),
                                                                _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(seatsAvailable)), 1)
                                                            ]),
                                                            _createElementVNode("tr", null, [
                                                                _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.$t('total_seats')), 1),
                                                                _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(workspace).seats), 1)
                                                            ])
                                                        ]),
                                                        _createVNode(_component_NumberField, {
                                                            modelValue: seatsToDelete.value,
                                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((seatsToDelete).value = $event)),
                                                            integer: "",
                                                            min: 0,
                                                            max: 999,
                                                            "hide-label": true
                                                        }, null, 8, ["modelValue"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_29, [
                                                        _createVNode(_component_TextButton, {
                                                            disabled: isDeleteSeatsLoading.value,
                                                            onClick: close
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                                            ], undefined, true),
                                                            _: 1
                                                        }, 8, ["disabled"]),
                                                        _createVNode(_component_PillButton, {
                                                            class: "min-w-34",
                                                            disabled: !!_unref(deleteSeatsDisabledReason),
                                                            loading: isDeleteSeatsLoading.value,
                                                            onClick: onDeleteSeats
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(seatsToDelete.value > 1 ? _ctx.$t('delete_plural') : _ctx.$t('delete')), 1)
                                                            ], undefined, true),
                                                            _: 1
                                                        }, 8, ["disabled", "loading"])
                                                    ])
                                                ], 64))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                    _createVNode(_component_PillButton, { onClick: close }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
                                                        ], undefined, true),
                                                        _: 1
                                                    })
                                                ]))
                                        ])
                                    ], undefined, true),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 1
                    }, 8, ["enter", "leave"])
                ], undefined, true),
                _: 1
            }));
        };
    }
});
